import { useState } from 'react';
import { InputTypes, InputWithButton } from 'taboola-ultimate-ui';
import { CREATIVE_TYPE } from 'modules/campaigns/config';
import { getValidationErrorMessage } from 'modules/campaigns/modules/creative-editor/components/MediaTabs/services/utils/fileValidationHelpers';
import { withIndication } from 'modules/errors';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { getValidationIndicationType } from 'modules/taboola-common-frontend-modules/validations/utils';
import styles from './urlInput.module.scss';

const UrlInputWithIndication = withIndication(InputWithButton);

const mediaType = { IMAGE: 'image' };

export const UrlInput = ({ setImageData }) => {
    const [urlInput, setUrlInput] = useState('');
    const [urlError, setUrlError] = useState();

    const { formatMessage } = useIntl();
    const urlPlaceholder = formatMessage({
        id: 'creative.editor.tab.aiGenerated.imageToMotion.url.placeholder',
        defaultMessage: 'http://cdn.taboolasyndication.com/libtrc/static/thumbnails/...',
    });
    const { mode } = useFormDataContext();

    const onUrlSendClick = async (url, metadata) => {
        const errorMessage = metadata
            ? null
            : await getValidationErrorMessage({
                  url,
                  mode,
                  creativeType: CREATIVE_TYPE.IMAGE,
                  mediaType,
              });

        if (errorMessage) {
            setUrlError(errorMessage);
            return;
        }

        setUrlError(null);
        setImageData({ value: url });
    };

    return (
        <>
            <div className={styles['url-header']}>
                <FormattedMessage
                    id="creative.editor.tab.aiGenerated.imageToMotion.url.header"
                    defaultMessage="or, type image URL address"
                />
            </div>

            <UrlInputWithIndication
                value={urlInput}
                placeholder={urlPlaceholder}
                onButtonClick={onUrlSendClick}
                onChange={setUrlInput}
                buttonLabel={
                    <FormattedMessage
                        id="creative.editor.tab.aiGenerated.imageToMotion.url.button"
                        defaultMessage="Add"
                    />
                }
                indicationType={getValidationIndicationType(urlError)}
                message={urlError && <FormattedMessage id={urlError} defaultMessage="Error" />}
                type={InputTypes.URL}
                size="large"
            />
        </>
    );
};
